module.exports = __webpack_public_path__ + "img/Avatar-22.a2a10e20.svg";